import {
  SET_OPEN_VENUES_FOR_BREAKFAST,
  SET_OPEN_VENUES_FOR_DINNER,
} from '../constants/dineAround';

const initialState = {
  openVenuesForBreakfast: null,
  openVenuesForDinner: null,
};

const dineAround = (state = initialState, action) => {
  switch (action.type) {
    case SET_OPEN_VENUES_FOR_BREAKFAST: {
      const { openVenues } = action;
      return { ...state, openVenuesForBreakfast: openVenues };
    }
    case SET_OPEN_VENUES_FOR_DINNER: {
      const { openVenues } = action;
      return { ...state, openVenuesForDinner: openVenues };
    }
    default:
      return state;
  }
};

export default dineAround;
